import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { mdiCalendarBlankOutline } from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment-timezone";
import React from "react";
import ResetMatchesConfirmDialog from "../../components/ResetMatchesConfirmDialog";
import AlreadyPlannedDialog from "../../components/schedule/AlreadyPlannedDialog";
import MatchesPlanner from "../../components/schedule/MatchesPlanner";
import defaultMatchTimes from "../../constants/DefaultMatchTimes";
import { languages } from "../../constants/languages";
import { getMatchDuration } from "../../util/GetMatchDuration";
import { groupBy } from "../../util/GroupBy";

class DivideMatchesContainer extends React.Component {
  state = {
    value: [],
    selectedValue: [],
    selectedFields: [],
    selectedFieldsValue: [],
    selectedRounds: [],
    selectedRoundsValue: [],
    roundOptions: [],
    showMessage: false,
    dividing: false,
    resetMatchesConfirm: false,
    resetMatchesConfirm2: false,
    selectedDays: [],
    selectedDaysValue: [],

    option: null,
    preventTwicePerWeek: false,
    planHallShift: false,
  };

  handlePreventTwicePerWeekChange = () => {
    this.setState({ preventTwicePerWeek: !this.state.preventTwicePerWeek });
  };

  handleHallShiftChange = () => {
    this.setState({ planHallShift: !this.state.planHallShift });
  };

  handleOptionChange = (option) => {
    if (this.state.option === option) {
      this.setState({ option: null });
    } else {
      this.setState({ option: option });
    }
  };

  handleClose = () => {
    this.setState({ showMessage: false });
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.selectedSportPark !== this.props.selectedSportPark) {
      this.setState({ selectedFields: [] });
    }
  };

  handleSelectChange = (e, value) => {
    // get round options
    let roundsCounter = [];
    let roundOptions = [];

    let selectedValue = [];
    let selectedElements = [];

    let lastValue = value[value.length - 1];
    let restValue = value.slice(0, value.length - 1);
    if (lastValue) {
      if (lastValue.value === "all") {
        if (restValue.find((v) => v.value === "all") === undefined) {
          selectedValue = [
            { value: "all", label: languages.schedule.allPoulesBrackets },
          ];
          selectedElements = this.props.pouleOptions.concat(
            this.props.bracketOptions,
          );
        }
      } else {
        selectedValue = value;
        selectedElements = value;
        if (restValue.find((v) => v.value === "all") !== undefined) {
          selectedElements.shift();
        }
      }
    }

    for (let i in selectedElements) {
      let selected = selectedElements[i];
      if (selected.isBracket) {
        let bracketPoules = this.props.bracketPoules.filter(
          (poule) => poule.bracket === selected.id,
        );
        let bracketRoundOptions = [];
        for (let p in bracketPoules) {
          let poule = bracketPoules[p];
          if (bracketRoundOptions.indexOf(poule.bracketRound) === -1) {
            bracketRoundOptions.push(poule.bracketRound);
          }
        }
        for (let r in bracketRoundOptions) {
          if (roundsCounter.indexOf(Number(r)) === -1) {
            roundOptions.push({
              value: Number(r),
              label: languages.schedule.round + " " + Number(Number(r) + 1),
            });
            roundsCounter.push(Number(r));
          }
        }
      } else {
        const matches = this.props.matches.filter(
          (match) => match.poule === selected.id,
        );
        for (let m in matches) {
          const match = matches[m];
          if (roundsCounter.indexOf(match.round) === -1) {
            roundOptions.push({
              value: match.round,
              label: languages.schedule.round + " " + Number(match.round + 1),
            });
            roundsCounter.push(match.round);
          }
        }
      }
    }
    roundOptions.sort((a, b) => a.value - b.value);
    let allRoundOptions = [];
    if (roundOptions.length > 0) {
      allRoundOptions = [
        {
          value: "allRounds",
          label: languages.schedule.allRounds,
        },
      ];
      roundOptions.forEach((o) => allRoundOptions.push(o));
    }

    this.setState({
      value: selectedElements,
      selectedValue: selectedValue,
      roundOptions: allRoundOptions,
      selectedRounds: roundOptions,
      selectedRoundsValue:
        roundOptions.length > 0
          ? [
              {
                value: "allRounds",
                label: languages.schedule.allRounds,
              },
            ]
          : [],
      option: null,
    });
  };

  handleSelectFieldsChange = (e, value) => {
    let selectedValue = [];
    let selectedElements = [];

    let lastValue = value[value.length - 1];
    let restValue = value.slice(0, value.length - 1);
    if (lastValue) {
      if (lastValue.value === "allFields") {
        if (restValue.find((v) => v.value === "allFields") === undefined) {
          selectedValue = [
            { value: "allFields", label: languages.schedule.allFields },
          ];
          selectedElements = Object.keys(this.props.tournament.fields || {})
            .map((key) => {
              let field = this.props.tournament.fields[key];
              field["value"] = key;
              field["label"] = field.name;
              return field;
            })
            .filter((field) => {
              let location = field.sportPark || "0";
              return location === this.props.selectedSportPark;
            });
        }
      } else {
        selectedValue = value;
        selectedElements = value;
        if (restValue.find((v) => v.value === "allFields") !== undefined) {
          selectedElements.shift();
        }
      }
    }
    this.setState({
      selectedFields: selectedElements,
      selectedFieldsValue: selectedValue,
      option: null,
    });
  };

  handleSelectRoundsChange = (e, value) => {
    let selectedValue = [];
    let selectedElements = [];

    let lastValue = value[value.length - 1];
    let restValue = value.slice(0, value.length - 1);
    if (lastValue) {
      if (lastValue.value === "allRounds") {
        if (restValue.find((v) => v.value === "allRounds") === undefined) {
          selectedValue = [
            { value: "allRounds", label: languages.schedule.allRounds },
          ];
          selectedElements = this.state.roundOptions.slice(1);
        }
      } else {
        selectedValue = value;
        selectedElements = value;
        if (restValue.find((v) => v.value === "allRounds") !== undefined) {
          selectedElements.shift();
        }
      }
    }
    this.setState({
      selectedRounds: selectedElements,
      selectedRoundsValue: selectedValue,
      option: null,
    });
  };

  handleSelectDaysChange = (e, value) => {
    let dayOptions = [
      {
        value: "0",
        label:
          moment
            .unix(this.props.tournament.date)
            .format(languages.schedule.dateFormatPlanner)
            .charAt(0)
            .toUpperCase() +
          moment
            .unix(this.props.tournament.date)
            .format(languages.schedule.dateFormatPlanner)
            .slice(1),
      },
    ];
    this.props.days
      .sort((a, b) => a.date - b.date)
      .forEach((day) => {
        let dayOption = day;
        dayOption["value"] = day.id;
        dayOption["label"] =
          moment
            .unix(dayOption.date)
            .format(languages.schedule.dateFormatPlanner)
            .charAt(0)
            .toUpperCase() +
          moment
            .unix(dayOption.date)
            .format(languages.schedule.dateFormatPlanner)
            .slice(1);
        dayOptions.push(dayOption);
      });

    let selectedValue = [];
    let selectedElements = [];

    let lastValue = value[value.length - 1];
    let restValue = value.slice(0, value.length - 1);
    if (lastValue) {
      if (lastValue.value === "allDays") {
        if (restValue.find((v) => v.value === "allDays") === undefined) {
          selectedValue = [
            { value: "allDays", label: languages.schedule.allDays },
          ];
          selectedElements = dayOptions;
        }
      } else {
        selectedValue = value;
        selectedElements = value;
        if (restValue.find((v) => v.value === "allDays") !== undefined) {
          selectedElements.shift();
        }
      }
    }
    this.setState({
      selectedDays: selectedElements,
      selectedDaysValue: selectedValue,
      option: null,
    });
  };

  divideMatches = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      let alreadyPlanned = false;

      let selectedPoules = this.state.value;
      let selectedRounds = this.state.selectedRounds.map(
        (round) => round.value,
      );
      selectedPoules.sort((a, b) => {
        if (a.fase > b.fase) {
          return 1;
        } else if (a.fase < b.fase) {
          return -1;
        } else if (a.division > b.division) {
          return 1;
        } else if (a.division < b.division) {
          return -1;
        } else if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else {
          return a.num - b.num;
        }
      });

      let poulesByFase = groupBy(selectedPoules, "fase");

      let matchesOrdered = [];
      let matchesOrderedPerRound = [];
      let matchIdsToPlan = [];
      let matchDuration = null;

      for (let i = 0; i < Object.keys(poulesByFase).length; i++) {
        let matchesPerRound = {};
        let fase = poulesByFase[Object.keys(poulesByFase)[i]];
        // console.log("fase", fase);
        for (let j in fase) {
          let poule = fase[j];
          let matches = [];
          // console.log("poule", poule);
          if (poule.isBracket) {
            let poules = this.props.bracketPoules
              .filter((bracketPoule) => bracketPoule.bracket === poule.id)
              .sort((a, b) => a.num - b.num);
            // console.log("bracket poules", poules);
            let bracketRounds = poules
              .map((b) => b.bracketRound)
              .filter((v, i, a) => a.indexOf(v) === i)
              .sort((a, b) => b - a);
            poules = poules.filter(
              (p) =>
                selectedRounds.indexOf(bracketRounds.indexOf(p.bracketRound)) >
                -1,
            );
            for (let x in poules) {
              let bracketPoule = poules[x];
              matches = matches.concat(
                this.props.matches
                  .filter((match) => match.poule === bracketPoule.id)
                  .sort(
                    (a, b) =>
                      this.props.poulesByKey[a.poule].num -
                      this.props.poulesByKey[b.poule].num,
                  ),
              );
            }
          } else {
            matches = this.props.matches
              .filter(
                (match) =>
                  match.poule === poule.id &&
                  selectedRounds.indexOf(match.round) > -1,
              )
              .sort((a, b) => a.numInPoule - b.numInPoule);
          }
          // console.log("matches", matches);
          for (let m in matches) {
            let match = matches[m];
            if (match.field !== null) {
              alreadyPlanned = true;
            }
            let roundNum = match.round;
            if (
              selectedPoules.filter((p) => !p.isBracket).length ===
                this.state.selectedFields.length &&
              Object.keys(poulesByFase).length === 1
            ) {
              roundNum = m;
            }
            // match["roundNumOverall"] = roundNum;

            if (matchesPerRound[roundNum] === undefined) {
              matchesPerRound[roundNum] = [];
            }
            matchesPerRound[roundNum].push(match);
          }
        }
        // console.log("matches per round", matchesPerRound);
        for (let r in Object.keys(matchesPerRound)) {
          let round = matchesPerRound[Object.keys(matchesPerRound)[r]];
          for (let m in round) {
            let match = round[m];
            matchesOrdered.push(match);
            matchIdsToPlan.push(match.id);
            if (matchDuration === null) {
              matchDuration = getMatchDuration(
                this.props.tournament,
                this.props.poulesByKey,
                match,
              );
            }
          }
        }
        Object.keys(matchesPerRound).forEach((r) => {
          matchesOrderedPerRound.push(matchesPerRound[r]);
        });
      }

      if (alreadyPlanned && this.state.showMessage === false) {
        this.setState({ showMessage: true });
      } else {
        // let validSchedule = true;
        let matchIdsDivided = [];
        let teamsDividedPerWeek = {};
        let teamsDivided = [];
        this.setState({ dividing: true });
        // console.log("Matches ordered:", matchesOrdered);
        // console.log("Match duration:", matchDuration);
        let dayIds = [this.props.selectedDay];
        if (this.state.selectedDays.length > 1) {
          dayIds = this.state.selectedDays.map((d) => d.value);
        }
        for (let i in dayIds) {
          let dayId = dayIds[i];

          let date = this.props.tournament.date;
          if (dayId !== "0") {
            let day = this.props.daysByKey[dayId];
            date = day.date;
          }
          let weekNum = moment.unix(date).isoWeek();
          if (teamsDividedPerWeek[weekNum] === undefined) {
            teamsDividedPerWeek[weekNum] = [];
          }
          let dayNum = moment.unix(date).isoWeekday();
          const db = window.firebase.firestore();
          let batch = db.batch();
          const affectedPairs = new Set();
          const matchesRef = db
            .collection("tournaments")
            .doc(this.props.tournament[".key"])
            .collection("matches");

          let fieldStartingNums = {};
          let fieldStartingTimes = {};
          let dividingFieldStartingTimes = {};
          let firstStartingTime = "0";
          let fieldWithFirstStartingTime = null;
          let fieldRoundsToSkip = {};
          let fieldBreaksToAdd = {};
          for (let i in this.state.selectedFields.sort((a, b) => a.id - b.id)) {
            const field = this.state.selectedFields[i];
            let breaks = Object.keys(this.props.tournament.breaks || {}).map(
              (key, i) => {
                let tournamentBreak = this.props.tournament.breaks[key];
                tournamentBreak["id"] = key;
                tournamentBreak["isBreak"] = true;
                return tournamentBreak;
              },
            );
            if (
              this.state.value.length ===
              this.props.pouleOptions.length + this.props.bracketOptions.length
            ) {
              Object.keys(breaks).forEach((key) => {
                let tournamentBreak = breaks[key];
                if (tournamentBreak.day === dayId && !tournamentBreak.isEvent) {
                  delete breaks[key];
                }
              });
            }
            const fieldMatches = this.props.matches
              .concat(breaks)
              .filter(
                (match) =>
                  match.field === field.id &&
                  matchIdsToPlan.indexOf(match.id) === -1 &&
                  match.day === dayId,
              )
              .sort((a, b) => {
                if (Number(a.numInField) > Number(b.numInField)) {
                  return 1;
                } else if (Number(a.numInField) < Number(b.numInField)) {
                  return -1;
                } else {
                  return 0;
                }
              });
            fieldStartingNums[field.id] =
              (fieldMatches[fieldMatches.length - 1] || {}).numInField || 0;

            let startTimestamp = field.startTime;
            if (dayId !== "0") {
              startTimestamp = field[dayId] || field.startTime;
            }

            fieldMatches.forEach((match, i) => {
              if (match.isBreak) {
                startTimestamp += Number(match.duration || 0) * 60;
              } else {
                startTimestamp +=
                  getMatchDuration(
                    this.props.tournament,
                    this.props.poulesByKey,
                    match,
                  ) * 60;
                startTimestamp +=
                  (this.props.tournament.timeBetweenMatches !== undefined
                    ? this.props.tournament.timeBetweenMatches
                    : defaultMatchTimes.timeBetweenMatches) * 60;
              }
            });
            fieldStartingTimes[field.id] = moment
              .unix(startTimestamp)
              .format("HH:mm");
            dividingFieldStartingTimes[field.id] = startTimestamp;
            // fieldStartingTimes[field.id] = startTimestamp;
            if (
              firstStartingTime === "0" ||
              moment.unix(startTimestamp).format("HH:mm") < firstStartingTime
            ) {
              firstStartingTime = moment.unix(startTimestamp).format("HH:mm");
              fieldWithFirstStartingTime = field.id;
            }
          }
          // console.log(fieldStartingNums);
          // console.log(fieldStartingTimes);
          // console.log(
          //   "firstStartingTime:",
          //   firstStartingTime,
          //   "Field:",
          //   fieldWithFirstStartingTime
          // );

          Object.keys(fieldStartingTimes).forEach((key) => {
            let firstStartTime = fieldStartingTimes[fieldWithFirstStartingTime];
            let firstStartTimeStamp = moment(firstStartTime, "HH:mm").unix();
            let startTime = fieldStartingTimes[key];
            let startTimeStamp = moment(startTime, "HH:mm").unix();
            if (key !== fieldWithFirstStartingTime) {
              for (let i = 0; i < 999; i++) {
                let firstStartTimeStampIncrease =
                  firstStartTimeStamp +
                  i * (Number(matchDuration) * 60) +
                  i *
                    (this.props.tournament.timeBetweenMatches !== undefined
                      ? this.props.tournament.timeBetweenMatches
                      : defaultMatchTimes.timeBetweenMatches) *
                    60;
                if (firstStartTimeStampIncrease >= startTimeStamp) {
                  let numRoundsToSkip = i;
                  let breakToAddDuration =
                    firstStartTimeStampIncrease - startTimeStamp;
                  if (numRoundsToSkip > 0) {
                    fieldRoundsToSkip[key] = i;
                  }
                  if (breakToAddDuration > 0) {
                    fieldBreaksToAdd[key] =
                      (firstStartTimeStampIncrease - startTimeStamp) / 60;
                    dividingFieldStartingTimes[key] =
                      dividingFieldStartingTimes[key] +
                      (firstStartTimeStampIncrease - startTimeStamp);
                  }
                  break;
                }
              }
            }
          });
          // console.log("fieldRoundsToSkip", fieldRoundsToSkip);
          // console.log("fieldBreaksToAdd", fieldBreaksToAdd);
          let newBreaks = [];
          let matchesPerFieldRound = {};
          let teamsPerFieldRound = {};
          let bracketRoundsPerFieldRound = {};
          let phasesPerFieldRoundPerDivision = {};

          let matchesToPlan = matchesOrdered;
          if (this.state.selectedDays.length > 1 && this.state.option === 1) {
            matchesToPlan = matchesOrderedPerRound[i] || [];
          }
          let matchesToPlanWithWishes = [];
          let teamsForDay = [];
          matchesToPlan.forEach((m) => {
            const poule = this.props.poulesByKey[m.poule] || {};
            let pouleKeyName = poule.fase;
            if (poule.bracket) {
              let bracket = this.props.bracketsByKey[poule.bracket] || {};
              pouleKeyName =
                poule.bracketRound === bracket.size && !bracket.subBracketTo
                  ? poule.fase
                  : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
            }
            let team1 =
              this.props.teams.find(
                (t) =>
                  t["poule" + pouleKeyName] === m.poule &&
                  t["numInPoule" + pouleKeyName] === m.team1,
              ) || {};
            let team2 =
              this.props.teams.find(
                (t) =>
                  t["poule" + pouleKeyName] === m.poule &&
                  t["numInPoule" + pouleKeyName] === m.team2,
              ) || {};
            let match = m;
            match["team1Object"] = team1;
            match["team2Object"] = team2;

            let validWeek = true;
            if (
              this.state.preventTwicePerWeek &&
              (teamsDividedPerWeek[weekNum].indexOf(team1.id) !== -1 ||
                teamsDividedPerWeek[weekNum].indexOf(team2.id) !== -1)
            ) {
              validWeek = false;
            }

            if (
              (team1.teamWishes || {}).notAvailable !== dayNum &&
              (team2.teamWishes || {}).notAvailable !== dayNum &&
              validWeek &&
              matchIdsDivided.indexOf(match.id) === -1
            ) {
              if (
                this.state.preventTwicePerWeek &&
                (teamsForDay.indexOf(team1.id) !== -1 ||
                  teamsForDay.indexOf(team2.id) !== -1)
              ) {
              } else {
                matchesToPlanWithWishes.push(match);
                if (team1.id) {
                  teamsForDay.push(team1.id);
                }
                if (team2.id) {
                  teamsForDay.push(team2.id);
                }
              }
            }
          });
          if (this.state.selectedDays.length > 1) {
            matchesToPlanWithWishes.sort((a, b) => {
              let matchAPrefScore = 0;
              let matchBPrefScore = 0;

              let team1A = a.team1Object;
              let team2A = a.team2Object;
              if ((team1A.teamWishes || {}).prefer === dayNum) {
                matchAPrefScore++;
              } else if ((team1A.teamWishes || {}).preferNot === dayNum) {
                matchAPrefScore--;
              }
              if (
                (team1A.teamWishes || {}).preferNot &&
                (team1A.teamWishes || {}).preferNot !== dayNum
              ) {
                matchAPrefScore++;
              }
              if (
                (team1A.teamWishes || {}).prefer &&
                (team1A.teamWishes || {}).prefer !== dayNum
              ) {
                matchAPrefScore--;
              }
              if ((team2A.teamWishes || {}).prefer === dayNum) {
                matchAPrefScore++;
              } else if ((team2A.teamWishes || {}).preferNot === dayNum) {
                matchAPrefScore--;
              }
              if (
                (team2A.teamWishes || {}).preferNot &&
                (team2A.teamWishes || {}).preferNot !== dayNum
              ) {
                matchAPrefScore++;
              }
              if (
                (team2A.teamWishes || {}).prefer &&
                (team2A.teamWishes || {}).prefer !== dayNum
              ) {
                matchAPrefScore--;
              }

              let team1B = b.team1Object;
              let team2B = b.team2Object;
              if ((team1B.teamWishes || {}).prefer === dayNum) {
                matchBPrefScore++;
              } else if ((team1B.teamWishes || {}).preferNot === dayNum) {
                matchBPrefScore--;
              }
              if (
                (team1B.teamWishes || {}).preferNot &&
                (team1B.teamWishes || {}).preferNot !== dayNum
              ) {
                matchBPrefScore++;
              }
              if (
                (team1B.teamWishes || {}).prefer &&
                (team1B.teamWishes || {}).prefer !== dayNum
              ) {
                matchBPrefScore--;
              }
              if ((team2B.teamWishes || {}).prefer === dayNum) {
                matchBPrefScore++;
              } else if ((team2B.teamWishes || {}).preferNot === dayNum) {
                matchBPrefScore--;
              }
              if (
                (team2B.teamWishes || {}).preferNot &&
                (team2B.teamWishes || {}).preferNot !== dayNum
              ) {
                matchBPrefScore++;
              }
              if (
                (team2B.teamWishes || {}).prefer &&
                (team2B.teamWishes || {}).prefer !== dayNum
              ) {
                matchBPrefScore--;
              }

              let roundNumOverallA = matchesOrderedPerRound.findIndex((arr) =>
                arr.find((m) => m.id === a.id),
              );
              let roundNumOverallB = matchesOrderedPerRound.findIndex((arr) =>
                arr.find((m) => m.id === b.id),
              );

              if (roundNumOverallA > roundNumOverallB) {
                return 1;
              } else if (roundNumOverallA < roundNumOverallB) {
                return -1;
              } else if (matchAPrefScore > matchBPrefScore) {
                return -1;
              } else if (matchAPrefScore < matchBPrefScore) {
                return 1;
              } else if (a.numInPoule > b.numInPoule) {
                return 1;
              } else if (a.numInPoule < b.numInPoule) {
                return -1;
              } else {
                return 0;
              }
            });
          }
          for (let i in matchesToPlanWithWishes) {
            let match = matchesToPlanWithWishes[i];
            let fieldRound = Math.floor(i / this.state.selectedFields.length);

            let validRound = false;
            while (validRound === false) {
              if (matchesPerFieldRound[fieldRound] === undefined) {
                matchesPerFieldRound[fieldRound] = [];
              }
              if (teamsPerFieldRound[fieldRound] === undefined) {
                teamsPerFieldRound[fieldRound] = {};
              }
              if (bracketRoundsPerFieldRound[fieldRound] === undefined) {
                bracketRoundsPerFieldRound[fieldRound] = [
                  this.props.poulesByKey[match.poule].bracket +
                    this.props.poulesByKey[match.poule].bracketRound,
                ];
              }

              let pouleKey = match.poule;
              let poule = this.props.poulesByKey[pouleKey] || {};
              if (
                phasesPerFieldRoundPerDivision[poule.division] === undefined
              ) {
                phasesPerFieldRoundPerDivision[poule.division] = {};
              }
              if (
                phasesPerFieldRoundPerDivision[poule.division][fieldRound] ===
                undefined
              ) {
                phasesPerFieldRoundPerDivision[poule.division][fieldRound] = [];
              }
              let validRoundForPhase =
                phasesPerFieldRoundPerDivision[poule.division][fieldRound].find(
                  (p) => p < poule.fase,
                ) === undefined;

              // console.log(
              //   bracketRoundsPerFieldRound,
              //   bracketRoundsPerFieldRound[fieldRound].indexOf(
              //     this.props.poulesByKey[pouleKey].bracketRound
              //   )
              // );
              // if (this.props.poulesByKey[pouleKey].bracket) {
              //   pouleKey = this.props.poulesByKey[pouleKey].bracket;
              // }
              if (teamsPerFieldRound[fieldRound][pouleKey] === undefined) {
                teamsPerFieldRound[fieldRound][pouleKey] = [];
              }

              let numFieldsForThisRound = this.state.selectedFields.length;
              for (let x in Object.keys(fieldRoundsToSkip)) {
                let r = fieldRoundsToSkip[Object.keys(fieldRoundsToSkip)[x]];
                if (fieldRound < r) {
                  numFieldsForThisRound = numFieldsForThisRound - 1;
                }
              }
              if (
                teamsPerFieldRound[fieldRound][pouleKey].indexOf(
                  pouleKey + match.team1,
                ) === -1 &&
                teamsPerFieldRound[fieldRound][pouleKey].indexOf(
                  pouleKey + match.team2,
                ) === -1 &&
                (!this.props.poulesByKey[pouleKey].bracket ||
                  bracketRoundsPerFieldRound[fieldRound].indexOf(
                    this.props.poulesByKey[pouleKey].bracket +
                      this.props.poulesByKey[pouleKey].bracketRound,
                  ) !== -1) &&
                matchesPerFieldRound[fieldRound].length <
                  numFieldsForThisRound &&
                validRoundForPhase
              ) {
                teamsPerFieldRound[fieldRound][pouleKey].push(
                  pouleKey + match.team1,
                );
                teamsPerFieldRound[fieldRound][pouleKey].push(
                  pouleKey + match.team2,
                );
                matchesPerFieldRound[fieldRound].push(match);
                phasesPerFieldRoundPerDivision[poule.division][fieldRound].push(
                  poule.fase,
                );
                validRound = true;
              } else {
                fieldRound++;
              }
            }
          }
          // console.log("matchesPerFieldRound", matchesPerFieldRound);
          Object.keys(fieldBreaksToAdd).forEach((key) => {
            let minutes = fieldBreaksToAdd[key];
            newBreaks.push({
              day: dayId,
              duration: minutes,
              field: key,
              numInField: Number(fieldStartingNums[key]) + 1,
              name: languages.schedule.empty,
            });
            fieldStartingNums[key]++;
          });
          // console.log(
          //   moment.unix(dividingFieldStartingTimes[0]).format("HH:mm")
          // );
          for (let r = 0; r < 100; r++) {
            // console.log(r, matchesPerFieldRound[r]);
            if ((matchesPerFieldRound[r] || []).length > 0) {
              let fieldsForRound = [];
              this.state.selectedFields.forEach((field) => {
                let roundEndTime =
                  dividingFieldStartingTimes[field.id] +
                  ((matchDuration
                    ? Number(matchDuration)
                    : defaultMatchTimes.matchDuration) +
                    (this.props.tournament.timeBetweenMatches !== undefined
                      ? Number(this.props.tournament.timeBetweenMatches)
                      : defaultMatchTimes.timeBetweenMatches)) *
                    60 *
                    (Number(r) + 1);
                let endTime = field.endTime || "";

                if (dayId !== "0") {
                  endTime =
                    field[dayId + "end"] !== undefined
                      ? field[dayId + "end"]
                      : field.endTime || "";
                }
                // console.log(
                //   "123",
                //   moment.unix(roundEndTime).format("HH:mm"),
                //   moment.unix(endTime).format("HH:mm"),
                //   moment.unix(roundEndTime).format("HH:mm") >
                //     moment.unix(endTime).format("HH:mm")
                // );
                if (
                  (fieldRoundsToSkip[field.id] &&
                    r < fieldRoundsToSkip[field.id]) ||
                  (moment.unix(roundEndTime).format("HH:mm") >
                    moment.unix(endTime).format("HH:mm") &&
                    endTime)
                ) {
                  //
                } else {
                  fieldsForRound.push(field);
                }
              });
              // console.log(r, fieldsForRound);
              if (fieldsForRound.length === 0) {
                break;
              }
              // console.log(fieldsForRound, matchesPerFieldRound);
              for (let i in fieldsForRound) {
                let match = (matchesPerFieldRound[r] || [])[i];
                let fieldId = fieldsForRound.sort((a, b) => a.id - b.id)[
                  i % this.state.selectedFields.length
                ].id;
                // console.log(fieldId);
                if (match) {
                  const matchRef = matchesRef.doc(match.id);

                  batch.update(matchRef, {
                    field: fieldId,
                    numInField:
                      Number(fieldStartingNums[fieldId]) + 1 + Number(r),
                    day: dayId,
                    referee: null,
                    referee2: null,
                    referee3: null,
                    referee4: null,
                    referee5: null,
                  });

                  // Add new match location to the affected pairs, so the cache will be updated for these pairs
                  affectedPairs.add(`${fieldId}__${dayId}`);
                  if (match.field !== null && match.field !== undefined) {
                    // Add also the old match location to the affected pairs, so the cache will be updated for these pairs
                    affectedPairs.add(`${match.field}__${match.day || "0"}`);
                  }
                  matchIdsDivided.push(match.id);

                  if ((match.team1Object || {}).id) {
                    if (
                      teamsDividedPerWeek[weekNum].indexOf(
                        match.team1Object.id,
                      ) === -1
                    ) {
                      teamsDividedPerWeek[weekNum].push(match.team1Object.id);
                    }
                    if (teamsDivided.indexOf(match.team1Object.id) === -1) {
                      teamsDivided.push(match.team1Object.id);
                    }
                  }

                  if ((match.team2Object || {}).id) {
                    if (
                      teamsDividedPerWeek[weekNum].indexOf(
                        match.team2Object.id,
                      ) === -1
                    ) {
                      teamsDividedPerWeek[weekNum].push(match.team2Object.id);
                    }
                    if (teamsDivided.indexOf(match.team2Object.id) === -1) {
                      teamsDivided.push(match.team2Object.id);
                    }
                  }

                  // teamsPerWeek
                  // console.log(
                  //   i,
                  //   fieldsForRound.length - 1,
                  //   (matchesPerFieldRound[r] || []).length,
                  //   fieldsForRound.length,
                  //   i === fieldsForRound.length - 1 &&
                  //     (matchesPerFieldRound[r] || []).length >
                  //       fieldsForRound.length
                  // );
                  if (
                    Number(i) === fieldsForRound.length - 1 &&
                    (matchesPerFieldRound[r] || []).length >
                      fieldsForRound.length
                  ) {
                    matchesPerFieldRound[r + 1] = matchesPerFieldRound[r]
                      .filter((m) => matchIdsDivided.indexOf(m.id) === -1)
                      .concat(matchesPerFieldRound[r + 1] || []);
                  }
                } else {
                  if (
                    this.state.selectedDays.length > 1 &&
                    this.state.option === 2
                  ) {
                    newBreaks.push({
                      day: dayId,
                      duration:
                        (this.props.tournament.matchDuration
                          ? Number(this.props.tournament.matchDuration)
                          : defaultMatchTimes.matchDuration) +
                        (this.props.tournament.timeBetweenMatches !== undefined
                          ? Number(this.props.tournament.timeBetweenMatches)
                          : defaultMatchTimes.timeBetweenMatches),
                      field: fieldId,
                      numInField:
                        Number(fieldStartingNums[fieldId]) + 1 + Number(r),
                      name: languages.schedule.empty,
                    });
                  } else {
                    let addedBreak = false;
                    for (let x in matchesPerFieldRound) {
                      if (x > r && addedBreak === false) {
                        for (let y in matchesPerFieldRound[x]) {
                          if (y === i) {
                            newBreaks.push({
                              day: dayId,
                              duration:
                                (this.props.tournament.matchDuration
                                  ? Number(this.props.tournament.matchDuration)
                                  : defaultMatchTimes.matchDuration) +
                                (this.props.tournament.timeBetweenMatches !==
                                undefined
                                  ? Number(
                                      this.props.tournament.timeBetweenMatches,
                                    )
                                  : defaultMatchTimes.timeBetweenMatches),
                              field: fieldId,
                              numInField:
                                Number(fieldStartingNums[fieldId]) +
                                1 +
                                Number(r),
                              name: languages.schedule.empty,
                            });
                            addedBreak = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          // console.log("newBreaks", newBreaks);
          const tournamentRef = window.firebase
            .firestore()
            .collection("tournaments")
            .doc(this.props.tournament[".key"]);
          let currentBreaks = this.props.tournament.breaks || {};

          if (
            this.state.value.length ===
            this.props.pouleOptions.length + this.props.bracketOptions.length
          ) {
            Object.keys(currentBreaks).forEach((key) => {
              let currentBreak = currentBreaks[key];
              if (currentBreak.day === dayId && !currentBreak.isEvent) {
                if (currentBreak.field !== undefined) {
                  affectedPairs.add(
                    `${currentBreak.field}__${currentBreak.day}`,
                  );
                }
                delete currentBreaks[key];
              }
            });
          }

          for (let br in newBreaks) {
            let newBreak = newBreaks[br];
            if (newBreak.field !== undefined) {
              affectedPairs.add(`${newBreak.field}__${newBreak.day}`);
            }
            const currentBreakKeys = Object.keys(currentBreaks).sort(
              (a, b) => a - b,
            );
            const newKey =
              Number(currentBreakKeys[currentBreakKeys.length - 1]) + 1 || 0;
            currentBreaks[newKey] = newBreak;
          }
          batch.update(tournamentRef, { breaks: currentBreaks });
          affectedPairs.forEach((pair) => {
            const [fieldId, dayId] = pair.split("__");
            batch.set(db.collection("cacheUpdates").doc(), {
              tournamentId: this.props.tournament[".key"],
              fieldId,
              dayId,
              status: "pending",
              timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
            });
          });
          if (this.props.tournament.ia) {
            batch.set(db.collection("cacheUpdatesApp").doc(), {
              tournamentId: this.props.tournament[".key"],
              status: "pending",
              timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
            });
          }
          batch.commit().then(() => {
            if (!this.state.planHallShift) {
              this.setState({
                selectedFields: [],
                selectedFieldsValue: [],
                showMessage: false,
                dividing: false,
              });
            }
          });
        }
        // console.log(teamsDivided);
        // hall shifts for fc lisse
        if (this.state.planHallShift) {
          // console.log("start hallshifts", teamsDivided, teamsDividedPerWeek);
          let hallShiftsToAdd = [];
          let numHallShiftsPerTeam = {};
          for (let i in dayIds) {
            let dayId = dayIds[i];
            let date = this.props.tournament.date;
            if (dayId !== "0") {
              let day = this.props.daysByKey[dayId];
              date = day.date;
            }
            let weekNum = moment.unix(date).isoWeek();

            let dayNum = moment.unix(date).isoWeekday();
            let candidates = teamsDivided.filter((tId) => {
              let t = this.props.teamsByKey[tId] || {};
              return (
                (t.teamWishes || {}).notAvailable !== dayNum &&
                (this.state.preventTwicePerWeek
                  ? teamsDividedPerWeek[weekNum].indexOf(tId) === -1
                  : true)
              );
            });
            candidates.sort((a, b) => {
              let aPrefScore = 0;
              let bPrefScore = 0;

              let team1 = this.props.teamsByKey[a] || {};
              let team2 = this.props.teamsByKey[b] || {};
              if ((team1.teamWishes || {}).prefer === dayNum) {
                aPrefScore++;
              } else if ((team1.teamWishes || {}).preferNot === dayNum) {
                aPrefScore--;
              }
              if (
                (team1.teamWishes || {}).preferNot &&
                (team1.teamWishes || {}).preferNot !== dayNum
              ) {
                aPrefScore++;
              }
              if ((team2.teamWishes || {}).prefer === dayNum) {
                bPrefScore++;
              } else if ((team2.teamWishes || {}).preferNot === dayNum) {
                bPrefScore--;
              }
              if (
                (team2.teamWishes || {}).preferNot &&
                (team2.teamWishes || {}).preferNot !== dayNum
              ) {
                bPrefScore++;
              }

              let numHallShiftsA = numHallShiftsPerTeam[a] || 0;
              let numHallShiftsB = numHallShiftsPerTeam[b] || 0;

              if (numHallShiftsA > numHallShiftsB) {
                return 1;
              } else if (numHallShiftsA < numHallShiftsB) {
                return -1;
              } else if (aPrefScore > bPrefScore) {
                return -1;
              } else if (aPrefScore < bPrefScore) {
                return 1;
              } else {
                return 0;
              }
            });
            let hallShiftTeams = [];
            if (candidates[0]) {
              hallShiftTeams.push(candidates[0]);
              if (numHallShiftsPerTeam[candidates[0]] === undefined) {
                numHallShiftsPerTeam[candidates[0]] = 1;
              } else {
                numHallShiftsPerTeam[candidates[0]]++;
              }

              if (teamsDividedPerWeek[weekNum].indexOf(candidates[0]) === -1) {
                teamsDividedPerWeek[weekNum].push(candidates[0]);
              }
            }
            let hallShift = {
              name: "Haldienst",
              duration: 0,
              teams: hallShiftTeams,
              field: (this.state.selectedFields[0] || {})["id"] || "0",
              day: dayId,
              numInField: -1,
              isEvent: true,
            };
            // console.log(
            //   "day",
            //   dayId,
            //   "team",
            //   candidates[0],
            //   "teamsForWeek",
            //   teamsDividedPerWeek[weekNum]
            // );
            hallShiftsToAdd.push(hallShift);
          }

          const db = window.firebase.firestore();
          let batch = db.batch();
          const tournamentRef = window.firebase
            .firestore()
            .collection("tournaments")
            .doc(this.props.tournament[".key"]);
          let currentBreaks = this.props.tournament.breaks || {};

          for (let br in hallShiftsToAdd) {
            let newBreak = hallShiftsToAdd[br];
            const currentBreakKeys = Object.keys(currentBreaks).sort(
              (a, b) => a - b,
            );
            const newKey =
              Number(currentBreakKeys[currentBreakKeys.length - 1]) + 1 || 0;
            currentBreaks[newKey] = newBreak;
          }
          batch.update(tournamentRef, { breaks: currentBreaks });
          batch.set(db.collection("cacheUpdatesForField").doc(), {
            tournamentId: this.props.tournament[".key"],
            fieldId: "0",
            status: "pending",
            timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
          });
          if (this.props.tournament.ia) {
            batch.set(db.collection("cacheUpdatesApp").doc(), {
              tournamentId: this.props.tournament[".key"],
              status: "pending",
              timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
            });
          }
          batch.commit().then(() => {
            this.setState({
              selectedFields: [],
              selectedFieldsValue: [],
              showMessage: false,
              dividing: false,
            });
          });
        }
      }
    }
  };

  toggleResetMatchesDialog = () => {
    this.setState({
      resetMatchesConfirm: !this.state.resetMatchesConfirm,
      resetMatchesConfirm2: false,
    });
  };

  setResetMatchesConfirm2 = () => {
    this.setState({
      resetMatchesConfirm2: true,
    });
  };

  resetMatches = () => {
    if (!this.state.resetMatchesConfirm) {
      this.toggleResetMatchesDialog();
    } else {
      for (let i = 0; i < 4; i++) {
        const db = window.firebase.firestore();
        let batch = db.batch();
        const matchesRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("matches");
        this.props.matches.slice(i * 500, (i + 1) * 500).forEach((match) => {
          let toUpdate = {
            field: null,
            day: "0",
            referee: "",
            referee2: "",
            referee3: "",
            referee4: "",
            referee5: "",
            st: "",
            et: "",
            duration: null,
          };

          batch.update(matchesRef.doc(match.id), toUpdate);
        });
        batch.commit();
      }
      let breaks = this.props.tournament.breaks || {};
      Object.keys(breaks).forEach((key) => {
        if (!breaks[key].isEvent) {
          delete breaks[key];
        } else {
          breaks[key]["field"] = null;
        }
      });

      const db = window.firebase.firestore();
      let batch = db.batch();
      batch.update(
        db.collection("tournaments").doc(this.props.tournament[".key"]),
        { breaks: breaks },
      );
      if (this.props.tournament.ia) {
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }
      batch.commit();
      this.toggleResetMatchesDialog();
    }
  };

  render() {
    let selectedPouleIds = [];
    let selectedRounds = this.state.selectedRounds.map((round) => round.value);
    for (let i in this.state.value) {
      let selected = this.state.value[i];
      if (selected.isBracket) {
        let bracketPoules = this.props.bracketPoules.filter(
          (poule) => poule.bracket === selected.id,
        );
        let bracketRounds = bracketPoules
          .map((b) => b.bracketRound)
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort((a, b) => b - a);
        for (let j in bracketPoules) {
          if (
            selectedRounds.indexOf(
              bracketRounds.indexOf(bracketPoules[j].bracketRound),
            ) > -1
          ) {
            selectedPouleIds.push(bracketPoules[j].id);
          }
        }
      } else {
        selectedPouleIds.push(selected.id);
      }
    }
    let selectedMatches = this.props.matches.filter((match) => {
      if (selectedPouleIds.indexOf(match.poule) > -1) {
        const poule = this.props.poulesByKey[match.poule] || {};
        if (poule.bracket) {
          return true;
        } else {
          return selectedRounds.indexOf(match.round) > -1;
        }
      } else {
        return false;
      }
    });

    let differentMatchDuration = false;
    let lastMatchDuration = null;
    for (let m in selectedMatches) {
      const match = selectedMatches[m];
      if (differentMatchDuration === false) {
        let duration = getMatchDuration(
          this.props.tournament,
          this.props.poulesByKey,
          match,
        );
        if (duration !== lastMatchDuration && lastMatchDuration !== null) {
          differentMatchDuration = true;
        } else {
          lastMatchDuration = duration;
        }
      }
    }
    let errorMessage = "";
    if (differentMatchDuration) {
      errorMessage = languages.schedule.differentDurationError;
    }

    let fieldOptions = Object.keys(this.props.tournament.fields || {})
      .sort((aKey, bKey) => {
        let a = this.props.tournament.fields[aKey];
        let b = this.props.tournament.fields[bKey];
        if (a.num > b.num) {
          return 1;
        } else if (a.num < b.num) {
          return -1;
        } else {
          return aKey - bKey;
        }
      })
      .map((key) => {
        let field = this.props.tournament.fields[key];
        field["value"] = key;
        field["label"] = field.name;
        return field;
      })
      .filter((field) => {
        let location = field.sportPark || "0";
        return location === this.props.selectedSportPark;
      });
    if (fieldOptions.length > 1) {
      fieldOptions.unshift({
        value: "allFields",
        label: languages.schedule.allFields,
      });
    }

    let dayOptions = [
      {
        value: "allDays",
        label: languages.schedule.allDays,
        id: "allDays",
      },
    ];
    let firstDay = this.props.tournament;
    firstDay["value"] = "0";
    firstDay["label"] =
      moment
        .unix(this.props.tournament.date)
        .format(languages.schedule.dateFormatPlanner)
        .charAt(0)
        .toUpperCase() +
      moment
        .unix(this.props.tournament.date)
        .format(languages.schedule.dateFormatPlanner)
        .slice(1);
    dayOptions.push(firstDay);
    this.props.days
      .sort((a, b) => a.date - b.date)
      .forEach((day) => {
        let dayOption = day;
        dayOption["value"] = day.id;
        dayOption["label"] =
          moment
            .unix(dayOption.date)
            .format(languages.schedule.dateFormatPlanner)
            .charAt(0)
            .toUpperCase() +
          moment
            .unix(dayOption.date)
            .format(languages.schedule.dateFormatPlanner)
            .slice(1);
        dayOptions.push(dayOption);
      });

    return (
      <div style={{ width: "100%" }}>
        {this.props.matches.length === 0 ? (
          <div style={{ width: "100%", textAlign: "center" }}>
            <Icon
              path={mdiCalendarBlankOutline}
              size={2}
              color={"rgba(0, 0, 0, 0.54)"}
              style={{ marginTop: 15 }}
            />
            <Typography>{languages.schedule.noMatchesToPlan}</Typography>
          </div>
        ) : (
          <MatchesPlanner
            value={this.state.value}
            selectedFields={this.state.selectedFields}
            handleSelectChange={this.handleSelectChange}
            handleSelectFieldsChange={this.handleSelectFieldsChange}
            handleSelectRoundsChange={this.handleSelectRoundsChange}
            selectedMatches={selectedMatches}
            divideMatches={this.divideMatches}
            {...this.state}
            {...this.props}
            fieldOptions={fieldOptions}
            errorMessage={errorMessage}
            dividing={this.state.dividing}
            resetMatches={this.resetMatches}
            dayOptions={dayOptions}
            handleSelectDaysChange={this.handleSelectDaysChange}
            handleOptionChange={this.handleOptionChange}
            handleHallShiftChange={this.handleHallShiftChange}
            handlePreventTwicePerWeekChange={
              this.handlePreventTwicePerWeekChange
            }
          />
        )}
        <AlreadyPlannedDialog
          open={this.state.showMessage}
          handleClose={this.handleClose}
          divideMatches={this.divideMatches}
          dividing={this.state.dividing}
        />
        <ResetMatchesConfirmDialog
          open={this.state.resetMatchesConfirm}
          handleClose={this.toggleResetMatchesDialog}
          resetMatches={this.resetMatches}
          resetMatchesConfirm2={this.state.resetMatchesConfirm2}
          setResetMatchesConfirm2={this.setResetMatchesConfirm2}
          dayOptions={dayOptions}
        />
        <Backdrop
          // className={classes.backdrop}
          style={{ zIndex: 9999, color: "#fff" }}
          open={this.state.dividing}
          // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    );
  }
}

export default DivideMatchesContainer;
